function initMainCart() {
  var form = document.querySelector('.main-cart__form');
  if (!form) return;

  var quantities = form.querySelectorAll('.main-cart__quantity');

  quantities.forEach(function (input) {
    input.addEventListener('change', function () {
      if (parseInt(input.value, 10) === 0 && input.dataset.index) {
        window.location.href =
          (window.Shopify && Shopify.routes && Shopify.routes.root
            ? Shopify.routes.root
            : '/') +
          'cart/change?line=' +
          input.dataset.index +
          '&quantity=0';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initMainCart);
document.addEventListener('shopify:section:load', initMainCart);
